/**
 * DOM media types/generic agora types.
 */

import type { ITrack } from 'agora-rtc-sdk-ng';

import type { Maybe, Optional } from '@vimeo/core/types/generic';

export enum EMediaError {
  INCOMPATIBLE_BROWSER = 1,
  DEVICE_BUSY = 2,
  NO_DEVICES = 3,
  DEVICE_ABORTED = 4,
  DEVICE_NOT_AVAILABLE = 5,
  DEVICE_UNPLUGGED = 6,
  INVALID_INTERVIEW_LINK = 7,
}

export enum EDeviceWeight {
  FACETIME = 'facetime',
  NORMAL = 'normal',
  UNKNOWN = 'unknown',
  OTHER = 'other',
  DISABLED = 'disabled',
}

export enum ETrackKind {
  VIDEO = 'video',
  AUDIO = 'audio',
}

export enum EVideoTransitionState {
  MANUAL = 'manual',
  AUTO = 'auto',
  LOOP = 'loop',
}

export enum EAudioMixingMode {
  ALL = 'ALL',
  SCENE = 'SCENE',
}

export enum EAudioVolume {
  MUTED = 0,
  FULL = 100,
}

export interface IExplicitActiveDevices {
  activeVideoDeviceId: string;
  activeAudioDeviceId: string;
}

export interface IActiveDevices {
  activeAudioDeviceId: string | boolean | null;
  activeVideoDeviceId: string | boolean | null;
}

export interface IDevicesBundle {
  audioDevices: Array<MediaDeviceInfo>;
  videoDevices: Array<MediaDeviceInfo>;
}

/**
 * WebRTC api content flag for encoder strategy selection.
 */

export type TVideoContentHint = '' | 'motion' | 'text' | 'detail';

export type TAudioContentHint = '' | 'speech' | 'music';

export interface IMediaConfig<T extends ITrack> {
  isLoading: boolean;
  isMuted: boolean;
  track: Optional<T>;
  deviceId: Maybe<string>;
  error: Optional<Error>;
}

export interface IMediaVideoConfig<T extends ITrack> extends IMediaConfig<T> {
  isBlurred: Optional<boolean>;
}
